import 'babel-polyfill'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import app from './app'
import i18n from './locales'
import router from './router'
import store from './store'
import logger from './logger'
import filters from './filters'
import VeeValidate from 'vee-validate'
import Paginate from 'vuejs-paginate'
import VueMask from 'v-mask'

var favicon = document.getElementById('favicon')
if (window.config.tenant === 'HATA') {
  favicon.href = '/static/hata-favicon-16x16.png'
  document.title = 'HATA | Customer Records'
} else {
  favicon.href = '/static/athena-favicon.ico'
  document.title = 'Athena'
}

Vue.config.productionTip = false

// error handler -> https://vuejs.org/v2/api/#errorHandler
Vue.config.errorHandler = logger

// filters
Object.keys(filters).forEach((filter) => {
  Object.keys(filters[filter]).forEach((f) => {
    Vue.filter(f, filters[filter][f])
  })
})

Vue.directive('disable-all', {
  // When all the children of the parent component have been updated
  componentUpdated: function (el, binding) {
    if (!binding.value) {
      return
    }
    const tags = ['input', 'button', 'textarea', 'select', 'radio-label', 'img']
    tags.forEach(tagName => {
      const nodes = el.getElementsByTagName(tagName)
      for (let i = 0; i < nodes.length; i++) {
        nodes[i].disabled = true
        nodes[i].tabIndex = -1
      }
    })
  }
})

// form validation
Vue.use(VeeValidate)

// pagination
Vue.component('paginate', Paginate)

// masked inputs
Vue.use(VueMask)

/* eslint-disable no-new */
window.app = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(app)
})



// WEBPACK FOOTER //
// ./src/main.js